import React from "react";
import { useRouteError } from "react-router-dom";
import { RouteErrorContent } from "../../components/RouteErrorContent";

/** Never render React Router's default error.message/stack page in production. */
export function RouteErrorPage() {
  const error = useRouteError();
  return <RouteErrorContent error={error} />;
}
